export default "__VITE_ASSET__d358359f__"